import { ENDPOINTS_GPROFILE } from './bbva-gapis.endpoints';

export default class GProfileService {

  constructor($http, $log, $q, accessTokenService) {
    'ngInject';
    this.http = $http;
    this.log = $log;
    this.q = $q;
    this.accessTokenService = accessTokenService;

    this.gprofile = null;
  }

  getSession() {
    if (this.gprofile){
      let deferred = this.q.defer();
      deferred.resolve(this.gprofile);
      return deferred.promise;
    }

    return this.http({
      method: 'POST',
      url: ENDPOINTS_GPROFILE.post.session(),
      headers: {
        'Skip-Request': 'true',
        'Authorization': 'Bearer ' + this.accessTokenService.getToken()
      },
    }).then((response) => {
      this.gprofile = response.data.data;
      this.log.info('GProfile Session', JSON.stringify(this.gprofile));
      return this.gprofile;
    });
  }

}




// WEBPACK FOOTER //
// ./client/app/mobile/bbva-gapis/gprofile.service.js